let viewgird = [
  //
  // ----------
  // 点巡检
  {
    path: '/Dev_PointTmp',
    name: 'Dev_PointTmp',
    component: () => import('@/views/device/inspection/Dev_PointTmp.vue')
  },
  {
    path: '/Dev_PointInspection',
    name: 'Dev_PointInspection',
    component: () => import('@/views/device/inspection/Dev_PointInspection.vue')
  },
  {
    path: '/Dev_PointDetail',
    name: 'Dev_PointDetail',
    component: () => import('@/views/device/inspection/Dev_PointDetail.vue')
  },
  {
    path: '/Dev_PointView',
    name: 'Dev_PointView',
    component: () => import('@/views/device/inspection/Dev_PointView.vue')
  },
  {
    path: '/Dev_PointAudit',
    name: 'Dev_PointAudit',
    component: () => import('@/views/device/inspection/Dev_PointAudit.vue')
  },
  {
    path: '/Dev_PointConfig',
    name: 'Dev_PointConfig',
    component: () => import('@/views/device/inspection/Dev_PointConfig.vue')
  },
  {
    path: '/Dev_PointConfigDet',
    name: 'Dev_PointConfigDet',
    component: () => import('@/views/device/inspection/Dev_PointConfigDet.vue')
  },
  {
    path: '/Dev_PointTmpDet',
    name: 'Dev_PointTmpDet',
    component: () => import('@/views/device/inspection/Dev_PointTmpDet.vue')
  },
  {
    path: '/Dev_RoutineInspection',
    name: 'Dev_RoutineInspection',
    component: () => import('@/views/device/inspection/Dev_RoutineInspection.vue')
  },
  {
    path: '/Dev_RoutineDetail',
    name: 'Dev_RoutineDetail',
    component: () => import('@/views/device/inspection/Dev_RoutineDetail.vue')
  },
  {
    path: '/Dev_RoutineView',
    name: 'Dev_RoutineView',
    component: () => import('@/views/device/inspection/Dev_RoutineView.vue')
  },
  {
    path: '/Dev_RoutineAudit',
    name: 'Dev_RoutineAudit',
    component: () => import('@/views/device/inspection/Dev_RoutineAudit.vue')
  },
  {
    path: '/Dev_RoutineTmp',
    name: 'Dev_RoutineTmp',
    component: () => import('@/views/device/inspection/Dev_RoutineTmp.vue')
  },
  {
    path: '/Dev_RoutineTmpDet',
    name: 'Dev_RoutineTmpDet',
    component: () => import('@/views/device/inspection/Dev_RoutineTmpDet.vue')
  },
  {
    path: '/Dev_RoutineConfig',
    name: 'Dev_RoutineConfig',
    component: () => import('@/views/device/inspection/Dev_RoutineConfig.vue')
  },
  {
    path: '/Dev_RoutineConfigDet',
    name: 'Dev_RoutineConfigDet',
    component: () => import('@/views/device/inspection/Dev_RoutineConfigDet.vue')
  },
  {
    path: '/Dev_RoleDeviceAuth',
    name: 'Dev_RoleDeviceAuth',
    component: () => import('@/views/device/Dev_RoleDeviceAuth.vue')
  },
  {
    path: '/Dev_RoleDeviceAuthTree',
    name: 'Dev_RoleDeviceAuthTree',
    component: () => import('@/views/device/Dev_RoleDeviceAuthTree.vue')
  },
  //
  // ----------
  // 备件管理
  {
    path: '/Dev_Materials',
    name: 'Dev_Materials',
    component: () => import('@/views/device/sparepartsmanagement/Dev_Materials.vue')
  },
  {
    path: '/Dev_MaterialApplicationApproval_Log',
    name: 'Dev_MaterialApplicationApproval_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialApplicationApproval_Log.vue')
  },
  {
    path: '/Dev_MaterialApproval_Log',
    name: 'Dev_MaterialApproval_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialApproval_Log.vue')
  },
  {
    path: '/Dev_MaterialInOut_Log',
    name: 'Dev_MaterialInOut_Log',
    component: () => import('@/views/device/sparepartsmanagement/Dev_MaterialInOut_Log.vue')
  },
  //
  // ----------
  // 维修管理
  {
    path: '/Dev_ConnectRepairDevice',
    name: 'Dev_ConnectRepairDevice',
    component: () => import('@/views/device/maintenancemanagement/Dev_ConnectRepairDevice.vue')
  },
  {
    path: '/Dev_DeviceRePairRequestForm',
    name: 'Dev_DeviceRePairRequestForm',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairRequestForm.vue')
  },
  {
    path: '/Dev_RepairTaskAccept',
    name: 'Dev_RepairTaskAccept',
    component: () => import('@/views/device/maintenancemanagement/Dev_RepairTaskAccept.vue')
  },
  {
    path: '/Dev_DeviceRePairApprove',
    name: 'Dev_DeviceRePairApprove',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairApprove.vue')
  },
  {
    path: '/Dev_RepairAudit',
    name: 'Dev_RepairAudit',
    component: () => import('@/views/device/maintenancemanagement/Dev_RepairAudit.vue')
  },
  {
    path: '/Dev_RepairDispatch',
    name: 'Dev_RepairDispatch',
    component: () => import('@/views/device/maintenancemanagement/Dev_RepairDispatch.vue')
  },
  {
    path: '/Dev_DeviceRePairLog',
    name: 'Dev_DeviceRePairLog',
    component: () => import('@/views/device/maintenancemanagement/Dev_DeviceRePairLog.vue')
  },
  {
    path: '/Dev_PersonalCalendar',
    name: 'Dev_PersonalCalendar',
    component: () => import('@/views/device/maintenancemanagement/Dev_PersonalCalendar.vue')
  },
  //
  // ----------
  // 保养
  {
    path: '/Dev_MaintainDetailedList',
    name: 'Dev_MaintainDetailedList',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainDetailedList.vue')
  },
  {
    path: '/Dev_MaintainPlan',
    name: 'Dev_MaintainPlan',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainPlan.vue')
  },
  {
    path: '/Dev_MaintainTask',
    name: 'Dev_MaintainTask',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTask.vue')
  },
  {
    path: '/Dev_MaintainTaskLog',
    name: 'Dev_MaintainTaskLog',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTaskLog.vue')
  },
  {
    path: '/Dev_MaintainTemplate',
    name: 'Dev_MaintainTemplate',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTemplate.vue')
  },
  {
    path: '/Dev_MaintainTaskDispatch',
    name: 'Dev_MaintainTaskDispatch',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTaskDispatch.vue')
  },
    {
    path: '/Dev_MaintainTaskAccept',
    name: 'Dev_MaintainTaskAccept',
    component: () => import('@/views/device/maintainmanage/Dev_MaintainTaskAccept.vue')
  },
  {
    path: '/Air_ServiceSheet',
    name: 'Air_ServiceSheet',
    component: () => import('@/views/device/air/Air_ServiceSheet.vue')
  },
  {
    path: '/Air_ServiceSheetItem',
    name: 'Air_ServiceSheetItem',
    component: () => import('@/views/device/air/Air_ServiceSheetItem.vue')
  },
  {
    path: '/Air_ServiceSheetPart',
    name: 'Air_ServiceSheetPart',
    component: () => import('@/views/device/air/Air_ServiceSheetPart.vue')
  },
  {
    path: '/Dev_ProcessConfig',
    name: 'Dev_ProcessConfig',
    component: () => import('@/views/device/maintainmanage/Dev_ProcessConfig.vue')
  },
    // 客户满意度评价列表页面（独立菜单页面，与保养接单平级）
  {
    path: '/CustomerEvaluationList',
    name: 'CustomerEvaluationList',
    component: () => import('@/views/device/maintainmanage/CustomerEvaluationList.vue')
  },
  // 客户满意度评价页面（独立页面，客户登录后操作）
  {
    path: '/CustomerEvaluation',
    name: 'CustomerEvaluation',
    component: () => import('@/views/device/maintainmanage/CustomerEvaluation.vue'),
    meta: {
      anonymous: true
    }
  },
  // 销售合同审核页面（单独页面）
  {
    path: '/SalesContractAudit',
    name: 'SalesContractAudit',
    component: () => import('@/views/device/maintainmanage/SalesContractAudit.vue'),
  },
  //员工信息
   {
    path: '/Air_Employee',
    name: 'Air_Employee',
    component: () => import('@/views/device/air/Air_Employee.vue')
  },
];

export default viewgird;
